document.addEventListener('DOMContentLoaded', function () {
  const takeQuizBottomBtn = document.querySelector(
    '.banner-with-text__without-image .banner-btn'
  );

  if (document.body.dataset.template.includes('black-friday')) {
    takeQuizBottomBtn?.addEventListener('click', () => {
      dataLayer.push({
        event: 'custom_event',
        event_name: 'black_friday_looking_for_more',
        parameter: ''
      });
    });
  } else if (
    document.body.dataset.template.includes('gift-guide') ||
    document.body.dataset.template.includes('leggings-guide') ||
    document.body.dataset.template.includes('bra-guide')
  ) {
    takeQuizBottomBtn?.addEventListener('click', () => {
      dataLayer.push({
        event: 'custom_event',
        event_name: 'gift_quide_take_quiz_click',
        parameter: JSON.stringify({
          button_location: 'bottom'
        })
      });
    });
  }

  document.querySelectorAll('.hero-btn, .hero-link').forEach(link => {
    link.addEventListener('click', () => {
      dataLayer.push({
        event: 'custom_event',
        event_name: 'gift_quide_take_quiz_click',
        parameter: JSON.stringify({
          button_location: 'top'
        })
      });
    });
  });

  const secondBannerBtn = document.querySelector(
    '.banner-with-text__with-image .banner-btn'
  );
  if (secondBannerBtn) {
    secondBannerBtn.addEventListener('click', () => {
      dataLayer.push({
        event: 'custom_event',
        event_name: 'gift_guide_secondary_banner_click',
        parameter: ''
      });
    });
  }

  const adventBannerLinks = document.querySelectorAll(
    '.gift-guide-banner-btn, .gift-guide-banner-link'
  );
  adventBannerLinks.forEach(link => {
    link.addEventListener('click', () => {
      dataLayer.push({
        event: 'custom_event',
        event_name: 'gift_guide_advent_banner_click',
        parameter: ''
      });
    });
  });

  document
    .querySelectorAll('.giftguide-blocks .swiper-slide a')
    .forEach(link => {
      link.addEventListener('click', () => {
        const value = link.closest('.swiper-slide')?.dataset.analyticsValue;
        if (!value) return;
        dataLayer.push({
          event: 'custom_event',
          event_name: 'gift_guide_price_card_click',
          parameter: JSON.stringify({ value })
        });
      });
    });

  const legacyPersonaValues = ['her', 'him', 'me'];
  const cardTypeEventNames = {
    persona: 'gift_guide_persona_card_click',
    color: 'gift_guide_color_card_click',
    activity: 'gift_guide_shop_by_activity'
  };

  document.querySelectorAll('[data-analytics-card-type]').forEach(section => {
    const cardType = section.dataset.analyticsCardType;
    const eventName = cardTypeEventNames[cardType];
    if (!eventName) return;

    section.querySelectorAll('.swiper-slide').forEach((slide, index) => {
      const cardText = slide
        .querySelector('a.tw-flex')
        ?.textContent.trim()
        .toLowerCase();
      const value =
        cardType === 'persona'
          ? (legacyPersonaValues[index] ?? cardText)
          : cardText;

      slide.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', () => {
          dataLayer.push({
            event: 'custom_event',
            event_name: eventName,
            parameter: JSON.stringify({ value: `${value}` })
          });
        });
      });
    });
  });
});
